"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentsService = void 0;
var rest_service_1 = require("./rest.service");
var enums_1 = require("../shared/enums");
/**
 * Class declaration
 */
var EnrollmentsService = /** @class */ (function (_super) {
    __extends(EnrollmentsService, _super);
    /**
     * constructor
     */
    function EnrollmentsService(brandService) {
        var _this = _super.call(this, {
            serviceName: enums_1.ServicesEnum.ENROLLMENT,
            baseURL: brandService.config.enrollmentServiceUrl,
        }) || this;
        _this.enrollmentsPath = 'enrollments';
        _this.academicSessionsPath = 'academicsessions';
        _this.schoolsGradingSummaryPath = '/schools/:schoolId/grade-summary';
        return _this;
    }
    /**
     * Get list of Enrollments
     * @param queryParams Object with
     *      - studentId: Student UUID
     *      - customerId: Customer UUID
     *      - beginDate: Begin Date
     *      - endDate: End Date
     *      - offset: number
     *      - limit: number
     * @returns Paginated enrollments
     */
    EnrollmentsService.prototype.listEnrollments = function (queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.search(this.enrollmentsPath, queryParams)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_1 = _a.sent();
                        throw new Error('Unable to get enrollments -> ' + rejectReason_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Post an Enrollment
     * @param enrollment
     * @returns Updated enrollment
     */
    EnrollmentsService.prototype.saveEnrollment = function (enrollment) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.enrollmentsPath, enums_1.RequestMethodEnum.POST, enrollment)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_2 = _a.sent();
                        throw new Error('Unable to post -> ' + rejectReason_2);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get an Enrollment
     * @param enrollmentId Enrollment UUID
     * @returns Enrollment
     */
    EnrollmentsService.prototype.getEnrollment = function (enrollmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.show(this.enrollmentsPath, enrollmentId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_3 = _a.sent();
                        throw new Error("Unable to get with identifier ".concat(enrollmentId, " -> ") + rejectReason_3);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update an Enrollment
     * @param enrollmentId Enrollment UUID to be updated
     * @param enrollment Enrollment
     * @returns Updated Enrollment
     */
    EnrollmentsService.prototype.updateEnrollment = function (enrollmentId, enrollment) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.update(this.enrollmentsPath, enrollment, enrollmentId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_4 = _a.sent();
                        throw new Error("Unable to update with identifier ".concat(enrollmentId, " -> ") + rejectReason_4);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get list of AcademicSessions
     * @param queryParams Object with
     *      - schoolId: School ID
     *      - offset: number
     *      - limit: number
     * @returns Paginated AcademicSession
     */
    EnrollmentsService.prototype.listAcademicSessions = function (queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.search(this.academicSessionsPath, queryParams)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_5 = _a.sent();
                        throw new Error('Unable to get academic sessions -> ' + rejectReason_5);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Post an AcademicSession
     * @param enrollment
     * @returns Updated AcademicSession
     */
    EnrollmentsService.prototype.saveAcademicSession = function (enrollment) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.academicSessionsPath, enums_1.RequestMethodEnum.POST, enrollment)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_6 = _a.sent();
                        throw new Error('Unable to post -> ' + rejectReason_6);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get an AcademicSession
     * @param uuid AcademicSession UUID
     * @returns AcademicSession
     */
    EnrollmentsService.prototype.getAcademicSession = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.show(this.academicSessionsPath, uuid)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_7 = _a.sent();
                        throw new Error("Unable to get with identifier ".concat(uuid, " -> ") + rejectReason_7);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update an AcademicSession
     * @param uuid AcademicSession UUID to be updated
     * @param academicSession AcademicSession
     * @returns Updated AcademicSession
     */
    EnrollmentsService.prototype.updateAcademicSession = function (uuid, academicSession) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.update(this.academicSessionsPath, academicSession, uuid)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_8 = _a.sent();
                        throw new Error("Unable to update with identifier ".concat(uuid, " -> ") + rejectReason_8);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return EnrollmentsService;
}(rest_service_1.RestService));
exports.EnrollmentsService = EnrollmentsService;
